export enum PricePerNights {
  Total,
  PerNight
}
